import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import type { PreviewEmailButtonProps } from '../../types';

export const PreviewEmailButton: React.FC<PreviewEmailButtonProps> = ({ disabled, onClick }) => {
	return (
		<Button
			className="w-full md:w-fit"
			variant="secondary"
			data-testid="preview-petition-update"
			data-qa="preview-petition-update"
			onClick={onClick}
			type="button"
			disabled={disabled}
			size="small"
		>
			<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.form.preview_button" />
		</Button>
	);
};
